<template>
  <b-card
      no-body
      border-variant="secondary"
      :header="$t('title.notes')"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
  >
        <b-card-body>
          <notes-tab></notes-tab>
        </b-card-body>


  </b-card>
</template>

<script>


import NotesTab from "./NotesTab";
export default {
  components: {NotesTab},
  data() {
    return {
      notes: null
    }
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
  },
  mounted() {
    this.getPlayer();
  },
  watch: {},
  methods: {
    getPlayer() {
      this.$store.dispatch('players/getPlayerNotes', this.$route.params.id).then(
          data => this.notes = data.items
      );
    }
  }
}
</script>
